const e = {
  "teaser-card": "teaser-card",
  "teaser-card__link": "teaser-card__link",
  "teaser-card__image": "teaser-card__image",
  "teaser-card__content": "teaser-card__content",
  "teaser-card__overline": "teaser-card__overline",
  "teaser-card__title": "teaser-card__title",
  "teaser-card__description": "teaser-card__description",
  "teaser-card__button": "teaser-card__button",
  "teaser-card--card": "teaser-card--card",
  "teaser-card--dashboard": "teaser-card--dashboard"
};
export {
  e as default
};
